import { useQuery } from "@apollo/client/react";

import { Maybe } from "types/generated";

import { GET_GITHUB_ENTERPRISE_INTEGRATION } from "./gql";

const useGetGitHubEnterpriseIntegration = (id: Maybe<string>) => {
  const { data, loading, error } = useQuery(GET_GITHUB_ENTERPRISE_INTEGRATION, {
    variables: {
      id,
    },
    fetchPolicy: "no-cache",
  });

  return {
    integration: data?.githubEnterpriseIntegration,
    isPageLoading: loading && !data?.githubEnterpriseIntegration,
    error,
  };
};

export default useGetGitHubEnterpriseIntegration;
